
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/power-backup",
      function () {
        return require("private-next-pages/power-backup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/power-backup"])
      });
    }
  